import React from "react";
import { FileText, ArrowRight, ArrowLeft } from "lucide-react";
import { Field, ErrorBox, INPUT } from "@/components/booking/parts";
import { PhoneField } from "@/components/booking/PhoneField";

export const Step3Details = ({ ctx }) => {
  const { t, v, lang, STEPS, form, update, setPhoneCc, setPhoneNumber, state, goSummary } = ctx;
  return (
    <div className="space-y-6" data-testid="step-details">
      <button data-testid="change-room-btn" onClick={() => window.history.back()} className="inline-flex items-center gap-2 text-sm text-[#1D3557] hover:underline">
        <ArrowLeft className="w-4 h-4" /> {v("changeRoom")}
      </button>
      <h2 className="font-display text-2xl md:text-3xl text-[#1A1A1A]">{STEPS[2]}</h2>
      <div className="grid md:grid-cols-2 gap-5">
        <Field label={t("booking.labels.firstName")} required>
          <input data-testid="input-first-name" required value={form.first_name} onChange={update("first_name")} className={INPUT} />
        </Field>
        <Field label={t("booking.labels.lastName")} required>
          <input data-testid="input-last-name" required value={form.last_name} onChange={update("last_name")} className={INPUT} />
        </Field>
      </div>
      <div className="grid md:grid-cols-2 gap-5">
        <Field label={t("booking.labels.email")} required>
          <input data-testid="input-email" type="email" required value={form.email} onChange={update("email")} className={INPUT} />
        </Field>
        <Field label={t("booking.labels.phone")} required>
          <PhoneField lang={lang} cc={form.phone_cc} number={form.phone_number} onCcChange={setPhoneCc} onNumberChange={setPhoneNumber} />
        </Field>
      </div>

      <div data-testid="booking-documents" className="p-5 rounded-2xl bg-[#F2EFEB] border border-[#1D3557]/15">
        <div className="flex items-center gap-2 mb-2">
          <FileText className="w-5 h-5 text-[#1D3557]" />
          <h3 className="font-display text-lg text-[#1A1A1A]">{t("documents.title")}</h3>
        </div>
        <p className="text-sm text-[#5C5C5C] leading-relaxed">{t("documents.intro")}</p>
        <ul className="mt-3 space-y-1.5">
          {t("documents.items").map((it, i) => (<li key={i} className="text-sm text-[#5C5C5C]"><span className="font-semibold text-[#1A1A1A]">{it.t}:</span> {it.d}</li>))}
        </ul>
        <p className="mt-3 text-sm text-[#5C5C5C]"><span className="font-semibold text-[#7A2B33]">{t("documents.notAcceptedLabel")}:</span> {t("documents.notAccepted")}</p>
      </div>

      <Field label={t("booking.labels.message")}>
        <textarea data-testid="input-message" rows={4} value={form.message} onChange={update("message")} className={INPUT} />
      </Field>

      {state.error && <ErrorBox msg={state.error} />}

      <button data-testid="continue-summary-btn" onClick={goSummary}
        className="w-full md:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-[#1D3557] text-white font-medium hover:bg-[#345B73] transition-all">
        {v("continueBtn")} <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};
